import { Option } from '@sapphire/result';
import { BasePayloadMapper } from '@ps/utils';
import {
  CompanyDetailRequestDto,
  CompanyDto,
  ProjectManagerDto,
} from '../dtos/company.dto';
import { CompanyDetailPayload } from '../../models/company.model';

export class CompanyPayloadMapper extends BasePayloadMapper<
  CompanyDetailPayload,
  CompanyDetailRequestDto
> {
  public toPayload(payload: CompanyDetailPayload): CompanyDetailRequestDto {
    return {
      name: payload.name,
      address: payload.address,
      phone: payload.phone,
      primaryLiaison: payload.primaryLiaison,
      secondaryLiaison: payload.secondaryLiaison,
      fx: payload.fx,
      isABuyer: payload.isABuyer,
      isASupplier: payload.isASupplier,
      isAnOperator: payload.isAnOperator,
      isFusion: payload.isFusion,
      isAServiceAccount: payload.isAServiceAccount,
      isTestAccount: payload.isTestAccount,
      generateInvoice: payload.generateInvoice,
      accountManagers: payload.accountManagers.map(
        (user): CompanyDto => ({ id: user.id, name: user.name }),
      ),
      projectManager: Option.from(payload.projectManager)
        .map(
          (projectManager): ProjectManagerDto => ({
            id: projectManager.id,
            name: projectManager.name,
            level: 1,
          }),
        )
        .unwrapOr({ level: 1 }),
      orgId: payload.orgId,
      supp_url_completes: payload.suppUrlCompletes,
      supp_url_overquota: payload.suppUrlOverquota,
      supp_url_terms: payload.suppUrlTerms,
      supp_url_security_terms: payload.suppUrlSecurityTerms,
      isNotify: payload.isNotify,
      isExpose: payload.isExpose,
      isAdditionalMetrics: payload.isAdditionalMetrics,
      isPureScoreEnable: payload.isPureScoreEnable,
      isRdFlagsEnable: payload.isRdFlagsEnable,
      appendProfileOnRedirects: payload.appendProfileOnRedirects,
      isIncludeBuyerInfoOnStatementReport:
        payload.isIncludeBuyerInfoOnStatementReport,
      isManualSupplier: payload.isManualSupplier,
      showTrafficChannel: payload.showTrafficChannel,
      nsInternalId: payload.nsInternalId ?? '',
      netsuite: Option.from(payload.netsuite)
        .map((netsuite) => ({
          enabled: netsuite.enabled,
          internalId: netsuite.internalId,
          companyName: netsuite.companyName,
          primaryEmail: netsuite.primaryEmail,
          billingInfo: {
            address: netsuite.billingAddress,
            city: netsuite.billingCity,
            state: netsuite.billingState,
            zip: netsuite.billingZip,
            country: netsuite.billingCountry,
          },
        }))
        .unwrapOr(undefined),
    };
  }
}
